export default "/_next/static/9720aced9f132fa110415f4bc31842ab.png";